var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "추천인 정책"
    }
  }), _c('v-row', {
    staticClass: "ma-n2 mt-n1"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('user-code-table', _vm._g(_vm._b({
    model: {
      value: _vm.codes,
      callback: function callback($$v) {
        _vm.codes = $$v;
      },
      expression: "codes"
    }
  }, 'user-code-table', {
    loading: _vm.loading,
    tempIdOnEdit: _vm.tempIdOnEdit
  }, false), {
    save: _vm.update,
    pull: _vm.remove,
    setTempIdOnEdit: _vm.setTempIdOnEdit
  }))], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }